import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { MenuItem } from "@mui/material";
import { IconButton } from "@mui/material";

import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { SquarePen } from "lucide-react";

import TabelaProcedimentos from "./Components/TabelaProcedimentos";
import SelectSituacao from "../../Components/SelectSituacao";
import Loading from "../../../../components/Loading";
import SelectFormaPagamento from "../../Components/SelectFormaPagamento";
import Header from "../../../../components/Header";

import AutoCompleteClientes from "../../../../componentsv2/AutoCompleteClientes";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import Container from "../../../../componentsv2/Container";

import { Context } from "../../../../Context/PermissoesContext";

import ModalProcedimento from "../ModalProcedimento";

import { api } from "../../../../services/Api";
import {
  OPCOES_LOCAL_ATENDIMENTO,
  OPCOES_MEDICACAO_ORIGEM,
  OPCOES_PAGAMENTO_STATUS,
} from "../../constants/agendamentoOptions";
import { abrirNoMaps, temEnderecoMinimo } from "../../utils/abrirNoMaps";
import { formatarMetadadosEvolucao } from "../../utils/evolucaoFormatters";

export default function EditarAgendamento() {
  const [openModalForm, setOpenModalForm] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState([]);

  const [situacao, setSituacao] = useState("");
  const [cliente, setCliente] = useState(null);
  const [endereco, setEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [complemento, setComplemento] = useState("");
  const [observacao, setObservacao] = useState("");
  const [totalExames, setTotalExames] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [localAtendimento, setLocalAtendimento] = useState("");
  const [medicacaoOrigem, setMedicacaoOrigem] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState("");
  const [nomeCliente, setNomeCliente] = useState("");
  const [cpfCliente, setCpfCliente] = useState("");
  const idAgendamento = useRef("");
  const inputPrescricoesRef = useRef(null);

  const [atualizaTabelaProcedimentos, setAtualizaTabelaProcedimentos] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [arquivosPrescricao, setArquivosPrescricao] = useState([]);
  const [prescricoes, setPrescricoes] = useState([]);
  const [loadingPrescricoes, setLoadingPrescricoes] = useState(false);
  const [evolucoes, setEvolucoes] = useState([]);
  const [novaEvolucao, setNovaEvolucao] = useState("");
  const [loadingEvolucoes, setLoadingEvolucoes] = useState(false);
  const [evolucaoEmEdicaoId, setEvolucaoEmEdicaoId] = useState(null);
  const [textoEvolucaoEdicao, setTextoEvolucaoEdicao] = useState("");
  const { checarPermissao } = useContext(Context);
  const atualizarTabelaProcedimentos = () => {
    setAtualizaTabelaProcedimentos(!atualizaTabelaProcedimentos);
  };

  const { enqueueSnackbar } = useSnackbar();

  const carregarPrescricoes = useCallback(
    async (agendamentoId) => {
      if (!agendamentoId) return;

      try {
        setLoadingPrescricoes(true);
        const {
          data: { data },
        } = await api.get(`/v2/agendaCare/agendamento/${agendamentoId}/prescricoes`);
        setPrescricoes(Array.isArray(data) ? data : []);
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.messages || "Não foi possível carregar as prescrições.", {
          variant: "warning",
        });
      } finally {
        setLoadingPrescricoes(false);
      }
    },
    [enqueueSnackbar]
  );

  const handleDownloadPrescricao = async (prescricao) => {
    if (!location.state?.row?.id || !prescricao?.id) return;

    try {
      const resposta = await api.get(
        `/v2/agendaCare/agendamento/${location.state.row.id}/prescricoes/${prescricao.id}/download`,
        { responseType: "blob" }
      );

      const blob = new Blob([resposta.data], {
        type: prescricao.mimeType || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = prescricao.nomeOriginal || "prescricao";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível baixar a prescrição.", {
        variant: "error",
      });
    }
  };

  const handleExcluirPrescricao = async (prescricaoId) => {
    if (!location.state?.row?.id || !prescricaoId) return;

    try {
      await api.delete(
        `/v2/agendaCare/agendamento/${location.state.row.id}/prescricoes/${prescricaoId}`
      );
      await carregarPrescricoes(location.state.row.id);
      enqueueSnackbar("Prescrição removida com sucesso.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível remover a prescrição.", {
        variant: "error",
      });
    }
  };

  const carregarEvolucoes = useCallback(
    async (agendamentoId) => {
      if (!agendamentoId) return;

      try {
        setLoadingEvolucoes(true);
        const {
          data: { data },
        } = await api.get(`/v2/agendaCare/agendamento/${agendamentoId}/evolucoes`);
        setEvolucoes(Array.isArray(data) ? data : []);
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.messages || "Não foi possível carregar as evoluções.", {
          variant: "warning",
        });
      } finally {
        setLoadingEvolucoes(false);
      }
    },
    [enqueueSnackbar]
  );

  const criarEvolucao = async () => {
    const descricao = novaEvolucao.trim();
    if (!descricao || !location.state?.row?.id) {
      enqueueSnackbar("Informe a evolução antes de salvar.", {
        variant: "warning",
      });
      return;
    }

    try {
      await api.post(`/v2/agendaCare/agendamento/${location.state.row.id}/evolucoes`, {
        descricao,
      });
      setNovaEvolucao("");
      await carregarEvolucoes(location.state.row.id);
      enqueueSnackbar("Evolução salva com sucesso.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível salvar a evolução.", {
        variant: "error",
      });
    }
  };

  const excluirEvolucao = async (evolucaoId) => {
    if (!location.state?.row?.id || !evolucaoId) return;

    try {
      await api.patch(
        `/v2/agendaCare/agendamento/${location.state.row.id}/evolucoes/${evolucaoId}/inativar`
      );
      await carregarEvolucoes(location.state.row.id);
      enqueueSnackbar("Evolução removida com sucesso.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível remover a evolução.", {
        variant: "error",
      });
    }
  };

  const iniciarEdicaoEvolucao = (evolucao) => {
    setEvolucaoEmEdicaoId(evolucao.id);
    setTextoEvolucaoEdicao(evolucao.descricao || "");
  };

  const cancelarEdicaoEvolucao = () => {
    setEvolucaoEmEdicaoId(null);
    setTextoEvolucaoEdicao("");
  };

  const salvarEdicaoEvolucao = async (evolucaoId) => {
    const descricao = textoEvolucaoEdicao.trim();
    if (!descricao || !location.state?.row?.id) {
      enqueueSnackbar("Informe a evolução antes de salvar.", {
        variant: "warning",
      });
      return;
    }

    try {
      await api.put(`/v2/agendaCare/agendamento/${location.state.row.id}/evolucoes/${evolucaoId}`, {
        descricao,
      });
      await carregarEvolucoes(location.state.row.id);
      cancelarEdicaoEvolucao();
      enqueueSnackbar("Evolução atualizada com sucesso.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível atualizar a evolução.", {
        variant: "error",
      });
    }
  };

  const enviarParaContasAReceber = async (dados) => {
    try {
      const buscaPorExistente = await api.get(
        `/v2/contasaReceber/contasAReceberOrigemId/${idAgendamento.current}`
      );
      const { data } = buscaPorExistente;
      if (data) {
        let { origem, origemId, cpfCliente, codigoPedido, valor } = dados;
        const dadosUpdateContas = {
          origem,
          cpfCliente,
          valor,
          codigoPedido,
          origemId,
        };
        await api.put(
          `/v2/contasaReceber/editarContasAReceber/${data.id}`,
          dadosUpdateContas
        );
        // enqueueSnackbar("Dados de Contas a Receber atualizados", {
        //   variant: "info",
        // });
        return;
      }

      await api.post(`/v2/contasaReceber/adicionaContasAReceber`, dados);
    } catch (error) {
      enqueueSnackbar(error.response.data.messages, {
        variant: "error",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const possuiValor = (value) => Boolean(String(value ?? "").trim());

      const camposObrigatorios = [
        { label: "Cliente", value: cliente?.id },
        { label: "Situação", value: situacao },
        { label: "Endereço", value: endereco },
        { label: "CEP", value: cep },
        { label: "Bairro", value: bairro },
        { label: "Cidade", value: cidade },
        { label: "Local", value: localAtendimento },
        { label: "Medicação", value: medicacaoOrigem },
        { label: "Pagamento", value: pagamentoStatus },
      ];
      const campoFaltante = camposObrigatorios.find(
        ({ value }) => !possuiValor(value)
      );
      if (campoFaltante) {
        enqueueSnackbar(`Preencha o campo obrigatório: ${campoFaltante.label}.`, {
          variant: "warning",
        });
        return;
      }
      if (procedimentoSelecionado.length === 0) {
        enqueueSnackbar("Selecione ao menos um procedimento.", {
          variant: "warning",
        });
        return;
      }

      const dados = {
        procedimentosId: procedimentoSelecionado,
        complemento,
        observacoes: observacao,
        situacao,
        cep,
        cidade,
        bairro,
        estado,
        endereco,
        clienteId: cliente.id,
        desconto: desconto ? desconto : 0,
        formaPagamento,
        localAtendimento,
        medicacaoOrigem,
        pagamentoStatus,
      };

      const dadosContasAReceber = {
        origem: "AGENDA CARE",
        origemId: idAgendamento.current,
        cpfCliente: cpfCliente,
        nome: nomeCliente,
        endereco,
        endereco_numero: "",
        complemento,
        bairro,
        cidade,
        estado,
        cep,
        celular: "",
        email: "",
        codigoPedido: "",
        valor: totalExames
          .replace("R$ ", "")
          .replace(",00", "")
          .replaceAll(".", ""),
      };
      if (situacao === "Realizado") {
        enviarParaContasAReceber(dadosContasAReceber);
      }

      await api.put(
        `v2/agendaCare/agendamento/${location.state.row.id}`,
        dados
      );

      if (arquivosPrescricao.length > 0) {
        setLoadingPrescricoes(true);
        const formData = new FormData();
        arquivosPrescricao.forEach((arquivoPrescricao) => {
          formData.append("file", arquivoPrescricao);
        });

        await api.post(
          `/v2/agendaCare/agendamento/${location.state.row.id}/prescricoes`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      history.push("/agendaCare");
      enqueueSnackbar("Alterações salvas com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      const status = error?.response?.status;
      if (status === 413) {
        enqueueSnackbar(
          error?.response?.data?.messages ||
            "Limite excedido: até 10MB por arquivo e no máximo 20 arquivos por envio.",
          {
          variant: "warning",
          }
        );
        return;
      }
      if (status === 415) {
        enqueueSnackbar(error?.response?.data?.messages || "Formato inválido. Envie PDF, JPG ou PNG.", {
          variant: "warning",
        });
        return;
      }

      enqueueSnackbar(
        error?.response?.data?.messages || "Erro! Não foi possível alterar os dados do agendamento.",
        {
          variant: "error",
        }
      );
    } finally {
      setLoadingPrescricoes(false);
    }
  };

  const pegarDadosAgendamento = useCallback(async () => {
    setLoading(true);
    if (location.state?.row) {
      try {
        const {
          data: { data },
        } = await api.get(`v2/agendaCare/agendamento/${location.state.row.id}`);
        const arrayIdProcedimentos = data.procedimentos.map((el) => el.id);
        setProcedimentoSelecionado(arrayIdProcedimentos);
        setSituacao(data.situacao);
        setCliente(data.cliente);
        setEndereco(data.endereco);
        setCep(data.cep);
        setBairro(data.bairro);
        setCidade(data.cidade);
        setComplemento(data.complemento);
        setObservacao(data.observacoes);
        setEstado(data.estado);
        setDesconto(data.desconto);
        setFormaPagamento(data.formaPagamento);
        setLocalAtendimento(data.localAtendimento);
        setMedicacaoOrigem(data.medicacaoOrigem);
        setPagamentoStatus(data.pagamentoStatus);

        idAgendamento.current = location.state.row.id;
        await carregarPrescricoes(location.state.row.id);
        await carregarEvolucoes(location.state.row.id);

        setNomeCliente(data.cliente.nome);
        setCpfCliente(data.cliente.cpf.replaceAll(" ", ""));
      } catch (error) {
        enqueueSnackbar(error.response.data.messages, {
          variant: "error",
        });
      }
    } else {
      history.push("/agendaCare");
    }
    setLoading(false);
  }, [carregarEvolucoes, carregarPrescricoes, enqueueSnackbar, history, location.state?.row]);

  useEffect(() => {
    pegarDadosAgendamento();
  }, [pegarDadosAgendamento]);

  return (
    <>
      <Header titulo="Editar Agendamento" />
      <Container>
        <Button onClick={() => history.push({ pathname: "/agendaCare" })}>
          <ArrowBackIcon style={{ color: "#003399" }} />
        </Button>
        <Paper style={{ padding: "40px", marginTop: "10px" }} elevation={2}>
          <form onSubmit={handleSubmit}>
            <GridContainer spacing={2} xs={12}>
              <GridContainer item xs={6} spacing={2}>
                <GridItem xs={3}>
                  <SelectSituacao
                    onChange={(e) => {
                      setSituacao(e.target.value);
                    }}
                    value={situacao}
                    todas={false}
                    required
                  />
                </GridItem>

                <GridItem xs={9}>
                  <AutoCompleteClientes
                    value={cliente}
                    onChange={setCliente}
                    required
                  />
                </GridItem>

                <GridItem xs={8}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setEndereco(e.target.value);
                    }}
                    value={endereco}
                    label="Endereço"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <SelectEstado
                    onChange={(e) => {
                      setEstado(e.target.value);
                    }}
                    value={estado}
                  />
                </GridItem>
                <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    size="small"
                    variant="text"
                    disabled={!temEnderecoMinimo({ endereco, cidade, cep })}
                    onClick={() =>
                      abrirNoMaps({
                        endereco,
                        numero: "",
                        bairro,
                        cidade,
                        estado,
                        cep,
                      })
                    }
                  >
                    Abrir no Maps
                  </Button>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCep(e.target.value);
                    }}
                    value={cep}
                    required
                    fullWidth
                    label="CEP"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setBairro(e.target.value);
                    }}
                    value={bairro}
                    required
                    fullWidth
                    label="Bairro"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCidade(e.target.value);
                    }}
                    value={cidade}
                    required
                    fullWidth
                    label="Cidade"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setComplemento(e.target.value);
                    }}
                    value={complemento}
                    fullWidth
                    label="Complemento"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Local"
                    value={localAtendimento}
                    onChange={(e) => setLocalAtendimento(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_LOCAL_ATENDIMENTO.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Medicação"
                    value={medicacaoOrigem}
                    onChange={(e) => setMedicacaoOrigem(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_MEDICACAO_ORIGEM.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Pagamento"
                    value={pagamentoStatus}
                    onChange={(e) => setPagamentoStatus(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_PAGAMENTO_STATUS.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setObservacao(e.target.value);
                    }}
                    value={observacao}
                    multiline
                    maxRows={5}
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="standard"
                  />
                </GridItem>

                <GridItem sm={4} xs={12}>
                  <SelectFormaPagamento
                    onChange={(e) => {
                      setFormaPagamento(e.target.value);
                    }}
                    value={formaPagamento}
                    required
                  />
                </GridItem>
                {checarPermissao("AGC002") && (
                  <>
                    <GridItem sm={4} xs={12}>
                      <Input
                        onChange={(e) => {
                          setDesconto(e.target.value);
                        }}
                        value={desconto}
                        fullWidth
                        label="Desconto R$:"
                        type="number"
                        variant="standard"
                      />
                    </GridItem>

                    <GridItem sm={4} xs={12}>
                      <Input
                        value={totalExames}
                        fullWidth
                        label="Total"
                        type="text"
                        inputProps={{ readOnly: true }}
                        variant="standard"
                      />
                    </GridItem>
                  </>
                )}

                <GridItem xs={12} style={{ marginTop: "12px" }}>
                  <h4 style={{ margin: "8px 0 12px 0" }}>Evolução do paciente</h4>
                  <div
                    style={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "10px",
                      padding: "16px",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <Input
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={5}
                      label="Nova evolução"
                      value={novaEvolucao}
                      onChange={(event) => setNovaEvolucao(event.target.value)}
                      variant="outlined"
                    />
                    <div style={{ marginTop: "14px", display: "flex", justifyContent: "flex-end" }}>
                      <Button type="button" variant="contained" color="blue" onClick={criarEvolucao}>
                        Salvar evolução
                      </Button>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "10px",
                      height: "165px",
                      overflowY: "auto",
                      paddingRight: "6px",
                    }}
                  >
                    {evolucoes.map((evolucao) => {
                      const emEdicao = evolucaoEmEdicaoId === evolucao.id;
                      const metadados = formatarMetadadosEvolucao(evolucao);
                      return (
                        <div
                          key={evolucao.id}
                          style={{
                            padding: "6px 0",
                            marginBottom: "4px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                              gap: "8px",
                            }}
                          >
                            <div style={{ fontSize: "10px", color: "#616161", lineHeight: 1.2 }}>
                              <strong>{metadados.usuario}</strong> - {metadados.dataHora}
                            </div>
                            {!emEdicao && (
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <IconButton
                                  onClick={() => iniciarEdicaoEvolucao(evolucao)}
                                  size="small"
                                >
                                  <SquarePen size={18} color="#003399" />
                                </IconButton>
                                <IconButton
                                  onClick={() => excluirEvolucao(evolucao.id)}
                                  size="small"
                                >
                                  <DeleteForeverIcon style={{ color: "#D32F2F", fontSize: "18px" }} />
                                </IconButton>
                              </div>
                            )}
                          </div>

                          {emEdicao ? (
                            <Input
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={5}
                              value={textoEvolucaoEdicao}
                              onChange={(event) => setTextoEvolucaoEdicao(event.target.value)}
                              variant="outlined"
                            />
                          ) : (
                            <div
                              style={{
                                fontSize: "12px",
                                marginBottom: "4px",
                                lineHeight: 1.25,
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {evolucao.descricao}
                            </div>
                          )}

                          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                            {emEdicao ? (
                              <>
                                <Button
                                  type="button"
                                  variant="outlined"
                                  color="gray"
                                  onClick={cancelarEdicaoEvolucao}
                                >
                                  Cancelar
                                </Button>
                                <Button
                                  type="button"
                                  variant="contained"
                                  color="blue"
                                  onClick={() => salvarEdicaoEvolucao(evolucao.id)}
                                >
                                  Salvar
                                </Button>
                                <Button
                                  type="button"
                                  variant="text"
                                  color="red"
                                  onClick={() => excluirEvolucao(evolucao.id)}
                                >
                                  Remover
                                </Button>
                              </>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}

                    {!loadingEvolucoes && evolucoes.length === 0 && (
                      <span style={{ fontSize: "14px", color: "#666" }}>
                        Nenhuma evolução registrada para este agendamento.
                      </span>
                    )}
                  </div>
                </GridItem>
              </GridContainer>

              <GridContainer item xs={6} spacing={2}>
                <GridItem xs={12}>
                  <TabelaProcedimentos
                    selectedRows={procedimentoSelecionado}
                    atualizaTabela={atualizaTabelaProcedimentos}
                    setSelectedRows={setProcedimentoSelecionado}
                    desconto={desconto}
                    setTotal={setTotalExames}
                  />
                </GridItem>
                <GridItem xs={12} style={{ marginTop: "16px" }}>
                  <h4 style={{ margin: "8px 0" }}>Prescrições</h4>
                  <div
                    style={{
                      border: "1px dashed #B0BEC5",
                      borderRadius: "10px",
                      minHeight: "110px",
                      padding: "14px 16px",
                      backgroundColor: "#FAFAFA",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="file"
                      ref={inputPrescricoesRef}
                      multiple
                      accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                      style={{ display: "none" }}
                      onChange={(event) => {
                        const arquivosSelecionados = Array.from(event.target.files || []);
                        setArquivosPrescricao(arquivosSelecionados);
                      }}
                    />
                    <Button
                      type="button"
                      variant="outlined"
                      style={{ color: "#0D47A1", fontSize: "16px", fontWeight: 600 }}
                      onClick={(event) => {
                        event.preventDefault();
                        inputPrescricoesRef.current?.click();
                      }}
                    >
                      Selecionar prescrições
                    </Button>
                    <span
                      style={{
                        marginTop: "14px",
                        fontSize: "14px",
                        color: "#424242",
                        fontWeight: 500,
                        textAlign: "center",
                      }}
                    >
                      PDF, JPG ou PNG - até 10MB por arquivo
                    </span>
                  </div>
                  {arquivosPrescricao.length > 0 ? (
                    <div style={{ marginTop: "10px" }}>
                      {arquivosPrescricao.map((arquivo) => (
                        <div
                          key={`${arquivo.name}-${arquivo.size}`}
                          style={{
                            fontSize: "16px",
                            color: "#616161",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "6px",
                          }}
                        >
                          <DescriptionOutlinedIcon style={{ fontSize: "20px" }} />
                          <span>{arquivo.name}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                      Nenhum arquivo novo selecionado.
                    </span>
                  )}
                  <div style={{ marginTop: "8px" }}>
                    <span style={{ fontSize: "13px", color: "#616161" }}>
                      Os arquivos novos selecionados serao enviados ao clicar em Salvar.
                    </span>
                  </div>
                  <div style={{ marginTop: "12px" }}>
                    {prescricoes.map((prescricao) => (
                      <div
                        key={prescricao.id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                          gap: "8px",
                        }}
                      >
                        <span style={{ fontSize: "14px" }}>{prescricao.nomeOriginal}</span>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
                            type="button"
                            variant="outlined"
                            onClick={() => handleDownloadPrescricao(prescricao)}
                          >
                            Baixar
                          </Button>
                          <Button
                            type="button"
                            color="red"
                            variant="outlined"
                            onClick={() => handleExcluirPrescricao(prescricao.id)}
                          >
                            Remover
                          </Button>
                        </div>
                      </div>
                    ))}
                    {!loadingPrescricoes && prescricoes.length === 0 && (
                      <span style={{ fontSize: "14px", color: "#666" }}>
                        Nenhuma prescrição salva neste agendamento.
                      </span>
                    )}
                  </div>
                </GridItem>
              </GridContainer>
            </GridContainer>

            {openModalForm && (
              <ModalProcedimento
                open={openModalForm}
                onClose={() => {
                  setOpenModalForm(false);
                  atualizarTabelaProcedimentos();
                }}
              />
            )}

            <GridContainer
              item
              sx={{ marginTop: "30px" }}
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                  color="gray"
                  variant="outlined"
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  id="agendarButton"
                  type="submit"
                  color="blue"
                  variant="contained"
                >
                  Salvar
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
      {loading && <Loading />}
    </>
  );
}
